import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { AdSense } from '../components/AdSense';

export function AboutPage() {
  return (
    <div>
      <Navbar />
      <div
        className="page-header bg-gradient text-white py-5"
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: '250px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="container">
          <h1 className="display-5 fw-bold">About Us</h1>
          <p className="lead">Learn more about Alo@laba Festival</p>
        </div>
      </div>

      <div className="container py-5">
        <section className="mb-5">
          <h2 className="mb-4">Our Mission</h2>
          <p className="lead">
            At Alo@laba, our mission is to create unforgettable festival experiences that bring people together—friends, families, 
            and communities—both locally and across borders. With our wide network of collaborators and co-workers, we aim to foster celebration, joy, and lasting memories through meaningful connections.
          
          </p>

         <p>
            Our platform empowers event organizers to showcase their parties and festivals, while making it simple for attendees to discover and 
            register for events that match their passions. By bridging cultures and communities, we make participation effortless and ensure that every celebration becomes a shared story of fun, unity, and togetherness.
 
          </p>

          <p>
            In addition to connecting people through unforgettable festivals, Alolaba offers a dynamic homepage experience designed to entertain, educate, and inspire. Visitors can enjoy live events streamed directly from our channel, as well as curated music and video content tailored to their interests and professional growth.
</p>

          <p>
By blending celebration with learning, our platform ensures that every participant can not only join in the fun but also explore educational and structured content that enriches their personal and professional journey. Whether it’s discovering new cultural rhythms or engaging with insightful videos, Alolaba makes every visit meaningful.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="mb-4">What We Offer</h2>
          <div className="row g-4">
            <div className="col-12 col-md-6">
              <div className="d-flex gap-3">
                <div style={{ fontSize: '2rem' }}>🎊</div>
                <div>
                  <h5>Event Management</h5>
                  <p>Easy Tools: Create, manage, and promote your events effortlessly.</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="d-flex gap-3">
                <div style={{ fontSize: '2rem' }}>📱</div>
                <div>
                  <h5>Mobile Friendly</h5>
                  <p>Cross-Device Access: Browse and register for events on any device</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="d-flex gap-3">
                <div style={{ fontSize: '2rem' }}>🔒</div>
                <div>
                  <h5>Secure Registration</h5>
                  <p>Data Protection: Your information is safe with our secure system.</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="d-flex gap-3">
                <div style={{ fontSize: '2rem' }}>💬</div>
                <div>
                  <h5>Community</h5>
                  <p>Local & Global Connections: Meet people in your area and beyond, building lasting friendships.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AdSense />

        <section>
          <h2 className="mb-4">Our Team</h2>
          <p>
            Our dedicated team is passionate about creating the best festival experience
            for everyone. We're constantly improving our platform to better serve you.
          </p>
          <div className="row g-4 mt-4">
            <div className="col-12 col-sm-6 col-md-4">
              <div className="card text-center">
                <div className="card-body">
                  <div style={{ fontSize: '3rem' }}>👨‍💼</div>
                  <h5 className="card-title">Team Lead</h5>
                  <p className="card-text text-muted">Founder & CEO</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="card text-center">
                <div className="card-body">
                  <div style={{ fontSize: '3rem' }}>👩‍💻</div>
                  <h5 className="card-title">Tech Expert</h5>
                  <p className="card-text text-muted">CTO & Developer</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="card text-center">
                <div className="card-body">
                  <div style={{ fontSize: '3rem' }}>👨‍🎨</div>
                  <h5 className="card-title">Design Pro</h5>
                  <p className="card-text text-muted">UX/UI Designer</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AdSense />

      <Footer />
    </div>
  );
}

export default AboutPage;
